import { createPhiSharedRuntimeDataProviderKey } from "./runtime-data-provider-key";

/**
 * The data providers every Site has, by the shared names they are registered under.
 *
 * Foundation vocabulary rather than the Core Module's: the keys live in the shared namespace, the
 * providers behind them sit with the shared Widget clients, and Foundation code -- the Layouts' spacing
 * fields -- names them. A Module's own fields may name them too.
 */
export const PHI_CORE_RUNTIME_DATA_PROVIDER_KEYS = {
  spacingScale: createPhiSharedRuntimeDataProviderKey("options", "spacing-scale"),
  siteLocales: createPhiSharedRuntimeDataProviderKey("options", "core-site-locales"),
  contentTable: createPhiSharedRuntimeDataProviderKey("tables", "content"),
  /** Every content kind's entries, one resource per kind (`CONTENT_ENTRIES.md`). */
  contentEntries: createPhiSharedRuntimeDataProviderKey("tables", "content-entries"),
  /** The tags one kind's entries already carry; the field names the kind in `config.kind`. */
  contentEntryTags: createPhiSharedRuntimeDataProviderKey("options", "content-entry-tags"),
  /** Who an entry of a kind may be attributed to; the field names the kind in `config.kind`. */
  contentEntryAuthors: createPhiSharedRuntimeDataProviderKey("options", "content-entry-authors"),
  /** The categories an entry of a kind may be filed under; the field names the kind in `config.kind`. */
  contentEntryCategoryOptions: createPhiSharedRuntimeDataProviderKey("options", "content-entry-categories"),
  /** Every content kind's categories, one resource per kind, as the Publisher keeps them. */
  contentEntryCategories: createPhiSharedRuntimeDataProviderKey("tables", "content-entry-categories"),
  /** One published entry and its relatives, read on the server; the binding names the kind and slug. */
  contentEntry: createPhiSharedRuntimeDataProviderKey("records", "content-entry"),
} as const;
